module.exports = __webpack_public_path__ + "static/sierra-code-83602e88c3d017c30e95e7e8ba4b86cf.png";